import { ILevelGeneralData } from 'src/app/infrastructure/models/level-general-data';
import { ICountryDto, countryDto } from 'src/assets/common/models/country-dto.g';

export const countryData = {
    guid: 'guid',
    isoCountryCode: 'isoCountryCode',
    isoLangCode: 'isoLangCode',
    englishName: 'englishName',
    dutchName: 'dutchName',
    formatMode: 'formatMode',
    countryName: 'countryName',
    deleted: 'deleted',
    inactive: 'inactive',
} as const;

export type TCountryData = (typeof countryData)[keyof typeof countryData];

export interface ICountryData extends ILevelGeneralData {
    [countryData.guid]: string;
    [countryData.isoCountryCode]: string | null;
    [countryData.isoLangCode]: string | null;
    [countryData.englishName]: string | null;
    [countryData.dutchName]: string | null;
    [countryData.formatMode]: string | null;
    [countryData.countryName]: string | null;
    [countryData.deleted]: boolean;
    [countryData.inactive]: boolean;
}

export class CountryData 
    implements ICountryData
{
    [countryData.guid]!: string;
    [countryData.isoCountryCode]: string | null = null;
    [countryData.isoLangCode]: string | null = null;
    [countryData.englishName]: string | null = null;
    [countryData.dutchName]: string | null = null;
    [countryData.formatMode]: string | null = null;
    [countryData.countryName]: string | null = null;
    [countryData.deleted]!: boolean;
    [countryData.inactive]!: boolean;

    private constructor(
        modelDto?: ICountryDto | null
    ) {
        if (modelDto) {
            this[countryData.isoCountryCode] = modelDto[countryDto.isoCountryCode];
            this[countryData.isoLangCode] = modelDto[countryDto.isoLangCode];
            this[countryData.englishName] = modelDto[countryDto.englishName];
            this[countryData.dutchName] = modelDto[countryDto.dutchName];
            this[countryData.formatMode] = modelDto[countryDto.formatMode];
            this[countryData.countryName] = modelDto[countryDto.dutchName] ?? modelDto[countryDto.englishName];
        }
    }

    static create(modelDto?: ICountryDto | null): ICountryData | null {
        return modelDto ? new CountryData(modelDto) : null;
    }
}
